(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sany-blueqr"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sany-blueqr')) {
    const SEEN = 'sany_passiton_seen';

    const seen = () => {
      try {
        return sessionStorage.getItem(SEEN) === '1';
      } catch {
        return false;
      }
    };

    const markSeen = () => {
      try {
        sessionStorage.setItem(SEEN, '1');
      } catch {}
    };

    class SanyBlueqr extends HTMLElement {
      connectedCallback() {
        this.sheet = this.querySelector('.sany-blueqr__sheet');
        this.mount = this.querySelector('[data-qrc-passiton]');
        if (!this.sheet || !this.mount || seen()) return;

        this.check = this.check.bind(this);
        this.observer = new MutationObserver(this.check);
        // The mount filling up, and BlueQR's card dialog coming and going.
        this.observer.observe(this.mount, { childList: true, subtree: true });
        this.observer.observe(document.body, { childList: true });

        this.sheet.addEventListener('click', (event) => {
          // A click on the backdrop lands on the dialog itself.
          if (event.target === this.sheet || event.target.closest('[data-close]')) this.sheet.close();
        });
        this.sheet.addEventListener('close', () => this.done());
      }

      disconnectedCallback() {
        this.stop();
      }

      /** BlueQR's own dialog (the sign-in card, or a share step) is open. */
      cardOpen() {
        return [...document.querySelectorAll('dialog[open]')].some((d) => d !== this.sheet);
      }

      check() {
        clearTimeout(this.timer);
        if (this.sheet.open || !this.mount.children.length || this.cardOpen()) return;
        // A beat after the card goes, so the two do not read as one popup.
        this.timer = setTimeout(() => {
          if (this.sheet.open || !this.mount.children.length || this.cardOpen() || seen()) return;
          markSeen();
          this.sheet.showModal();
        }, 700);
      }

      done() {
        this.stop();
        // Closed means closed: no buttons left behind anywhere on the page.
        this.sheet.remove();
      }

      stop() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
      }
    }

    customElements.define('sany-blueqr', SanyBlueqr);
  }

  } catch(e) { console.error(e); }
})();
})();
